import React, { useEffect, useState } from 'react';
import Page from '@/model/Page';
import Event from '@/model/Event';
import { useDialog } from '@/hooks/useDialog';
import { AxiosError } from 'axios';
import api from '@/services/api';
import { toast } from 'react-toastify';
import useForm from '@/hooks/useForm';
// import validators from '@/helpers/validators';
import { useFinancialPageFilter } from '@/context/FinancialPageContext';
import { updateMask as updateMaskDate } from '@/helpers/masks/generalDate';
import EventStatus from '@/model/EventStatus';
import { FormInput, ShouldShowModal, States } from '../types';
import { FinancialContainer } from './ui';

export const FinancialScreen: React.FC = (): JSX.Element => {
  const [state, setState] = useState<States>(States.default);
  // const [page, setPage] = useState<Page<Event, Event>>({
  //   page: 1,
  //   pageSize: 10,
  //   sort: 'startDate',
  //   order: 'DESC',
  // });
  const { page, setPage, clearPage } = useFinancialPageFilter();
  const [shouldShowModal, setShouldShowModal] = useState<ShouldShowModal>(ShouldShowModal.filter);
  const { title, visible, onChangeTitle, onToggle } = useDialog();

  const handleOnPage = async (pageData: Page<Event, Event>): Promise<void> => {
    try {
      setState(States.loading);
      const { data } = await api.post<Page<Event, Event>>(
        '/event-money-transfer/finantial/event/page',
        pageData,
      );
      if (data) {
        setPage(data);
      }
    } catch (error) {
      const err = error as AxiosError;
      if (err.response?.status !== 401) {
        toast.error(err.message);
      }
    } finally {
      setState(States.default);
    }
  };

  const { formData, formErrors, onChangeFormInput, resetForm } = useForm({
    initialData: {
      historical: 'false',
      filterSearch: '',
      inputSearch: '',
      startDate: '',
      endDate: '',
    },
    formatters: { startDate: updateMaskDate, endDate: updateMaskDate },
  });

  const handleOnClearFilter = async (): Promise<void> => {
    resetForm();
    const newPage: Page<Event, Event> = {
      page: 1,
      entity: {
        eventStatus: EventStatus.ACTIVE,
      } as Event,
      pageSize: 10,
      sort: 'startDate',
      order: 'DESC',
    };
    clearPage();
    await handleOnPage(newPage);
  };

  const convertDate = (d: string): Date => {
    const [day, month, year] = d.split('/');
    return new Date(`${year}-${month}-${day}T12:00:00.000Z`);
  };

  const handleOnFilter = async (): Promise<void> => {
    if (
      formData[FormInput.historical] ||
      formData[FormInput.inputSearch] ||
      formData[FormInput.startDate]
    ) {
      const newPage: Page<Event, Event> = {
        ...page,
        entity: {
          name: formData[FormInput.inputSearch],

          eventStatus:
            formData[FormInput.historical] === 'false' ? EventStatus.ACTIVE : EventStatus.FINISHED,

          startDate: convertDate(formData[FormInput.startDate]),
          endDate: convertDate(formData[FormInput.endDate]),
        } as Event,
      };
      setPage(newPage);
      onToggle();

      await handleOnPage(newPage);
    }
  };

  const handleOnShouldShowModal = ({
    value,
    newTitleModal,
  }: {
    value: ShouldShowModal;
    newTitleModal: string | React.ReactNode;
  }): void => {
    setShouldShowModal(value);
    onChangeTitle(newTitleModal);
    onToggle();
  };

  const handleOnPaginationChange = async (newPageNumber: number): Promise<void> => {
    const newPage: Page<Event, Event> = {
      ...page,
      page: newPageNumber,
    };
    await handleOnPage(newPage);
  };

  useEffect(() => {
    handleOnPage(page);
  }, []);
  return (
    <FinancialContainer
      state={state}
      title={title}
      visible={visible}
      onToggle={onToggle}
      page={page}
      onPaginationChange={handleOnPaginationChange}
      onShouldShowModal={handleOnShouldShowModal}
      shouldShowModal={shouldShowModal}
      formData={formData}
      formErrors={formErrors}
      onChangeFormInput={onChangeFormInput}
      onClearFilter={handleOnClearFilter}
      onFilter={handleOnFilter}
    />
  );
};
